<template>
<v-container fluid>
    <h4 class="text-h4 ml-16 mt-8 mb-8">Notifications</h4>
    <v-dialog
      v-model="deleteItemDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Are you sure?
        </v-card-title>

        <v-card-text>
          Do you really want to delete this notification? This process cannot be undone. 
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="secondary darken-1"
            text
            @click="deleteItemDialog = false; cancelDeletion();"
          >
            Cancel
          </v-btn>

          <v-btn
            color="error darken-1"
            text
            @click="deleteItemDialog = false; confirmDeletion();"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-iterator
        :items="getNotifications"
        :items-per-page.sync="itemsPerPage"
        :page="page"
        hide-default-footer
    >
        <template v-slot:default="props">
            <v-divider />
            <v-list>
                <template v-for="(item, index) in props.items">
                    <v-list-item
                        :key="'i'+index"
                        @click="doNothing()"
                    >
                        <v-avatar @click="actionClick(item, 'toggleAck')">
                            <v-icon
                                v-if="!item.isAcknowledge"
                                color="info">
                                mdi-email-outline
                            </v-icon>

                            <v-icon
                                v-else>
                                mdi-email-open-outline
                            </v-icon>
                        </v-avatar>
                        <v-list-item-content @click="actionClick(item, 'link')">
                            <v-list-item-title v-text="item.title" v-bind:class="{ 'font-weight-medium': !item.isAcknowledge }"></v-list-item-title>
                            <v-list-item-subtitle v-text="item.description"></v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-list-item-action-text> {{ item.updatedDate | moment("from") }}</v-list-item-action-text>
                            <v-btn color="error" fab x-small dark @click="actionClick(item, 'delete')">
                                <v-icon>mdi-trash-can</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                    <v-divider
                        v-if="index + 1 < getNotifications.length"
                        :key="index"
                    ></v-divider>
                </template>
                <v-divider />
            </v-list>
        </template>
        <v-spacer vertical />
        <template v-slot:footer>
            <v-row class="ma-2" align="center" justify="center">
                <span class="grey--text">Items per page</span>
                <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                    dark
                    text
                    color="primary"
                    class="ml-2"
                    v-bind="attrs"
                    v-on="on"
                    >
                    {{ itemsPerPage }}
                    <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item
                    v-for="(number, index) in itemsPerPageArray"
                    :key="index"
                    @click="updateItemsPerPage(number)"
                    >
                    <v-list-item-title>{{ number }}</v-list-item-title>
                    </v-list-item>
                </v-list>
                </v-menu>

                <v-spacer></v-spacer>

                <span
                class="mr-4
                grey--text"
                >
                Page {{ page }} of {{ numberOfPages }}
                </span>
                <v-btn
                fab
                dark
                color="blue darken-3"
                class="mr-1"
                @click="formerPage"
                >
                <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn
                fab
                dark
                color="blue darken-3"
                class="ml-1"
                @click="nextPage"
                >
                <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </v-row>
        </template>
    </v-data-iterator>
    </v-container>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    export default {
        data () {
            return {
                itemsPerPageArray: [15, 25, 50],
                filter: {},
                deleteItemDialog: false,
                preDelete: {},
                page: 1,
                itemsPerPage: 15
            }
        },
        computed: {
            ...mapGetters(['getNotifications']),
            numberOfPages () {
                return Math.ceil(this.getNotifications.length / this.itemsPerPage)
            },
            filteredKeys () {
                return this.keys.filter(key => key !== `Name`)
            },
        },
        methods: {
            ...mapActions(['toggleAckNotification', 'deleteNotification', 'sendMessage']),
            nextPage () {
                if (this.page + 1 <= this.numberOfPages) this.page += 1
            },
            formerPage () {
                if (this.page - 1 >= 1) this.page -= 1
            },
            updateItemsPerPage (number) {
                this.itemsPerPage = number
            },
            doNothing() { return },
            actionClick(item, action) {
                if (action === 'link') {
                    this.$router.push({ path: item.link });
                }
                if (action === 'toggleAck') {
                    this.toggleAckNotification(item.id);
                }
                if (action === 'delete') {
                    this.deleteItemDialog = true;
                    this.preDelete = item;
                }
            },
            cancelDeletion() {
                this.preDelete = {};
            },
            confirmDeletion() {
                if(this.preDelete) {
                    this.deleteNotification(this.preDelete.id);
                    this.sendMessage({
                        color: "success",
                        text: `The notification ${this.preDelete.title} has been successfuly deleted.`,
                        timeout: 6000
                    });
                }
            }
        },
    }
</script>

<style>

</style>